import { render, staticRenderFns } from "./InterventionPhotos.vue?vue&type=template&id=fedcb624"
import script from "./InterventionPhotos.vue?vue&type=script&lang=ts"
export * from "./InterventionPhotos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports